import React from "react";
import styles from "../styles/pages/resume.module.css";

function Resume() {
    return <div className={styles.resume}>
        <h1>Resume</h1>
        <div className={`${styles.degree} ${styles.active}`}>
            <div className={styles.degreeItem}>
                <h2 className={styles.degreeTitle}>French National Brevet Diploma</h2>
                <p className={styles.degreeDate}>2019 - 2023</p>
                <p className={styles.degreeDescription}>Equivalent to a Middle School Certificate</p>
                <a href="./" className={styles.download}>Download</a>
            </div>
        </div>
        <h1>My current state</h1>
        <div className={`${styles.degree}`}>
            <div className={styles.degreeItem}>
                <h2 className={styles.degreeTitle}>French General Baccalaureate in Mathematics and Computer Science</h2>
                <p className={styles.degreeDate}>2023 - 2026</p>
                <p className={styles.degreeDescription}>Equivalent to a High School Diploma + Advanced Placement (AP) Courses</p>
                {/* <a href="./" className={styles.download}>Download</a> */}
            </div>
        </div>
        <h1>The path i would like to follow</h1>
        <div className={`${styles.degree}`}>
            <div className={styles.degreeItem}>
                <h2 className={styles.degreeTitle}>French Double University License in Mathematics and Computer Science</h2>
                <p className={styles.degreeDate}>2026 - 2029</p>
                <p className={styles.degreeDescription}>Equivalent to the sum of two Bachelor Degrees, one in CS and one in Maths</p>
                {/* <a href="./" className={styles.download}>Download</a> */}
            </div>
        </div>
        <div className={`${styles.degree}`}>
            <div className={styles.degreeItem}>
                <h2 className={styles.degreeTitle}>International Joint Master Degree in Computer Science (With Erasmus Mundus)</h2>
                <p className={styles.degreeDate}>2029 - 2031</p>
                <p className={styles.degreeDescription}>A prestigious Master Degree, Studying in multiples europeans universities in the span of two years</p>
                {/* <a href="./" className={styles.download}>Download</a> */}
            </div>
        </div>
    </div>;
}

export default Resume;
